import { useEffect, useRef } from 'react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { PaginatedListRefType } from '@frontend/components';

export const useScrollToTopOnNewPerson = (firstPersonId: string | undefined) => {
  const paginatedListRef = useRef<PaginatedListRefType>(null);
  const newPersonIdRef = useRef<string>();

  SchedulerV3.useWaitlistCustomEventListener('schedule:waitlist:person-added', ({ personId }) => {
    newPersonIdRef.current = personId;
  });

  useEffect(() => {
    // scroll to top of list when new person is added to list
    if (newPersonIdRef.current === firstPersonId) {
      paginatedListRef.current?.scrollToTop();
    }
  }, [firstPersonId]);

  return { paginatedListRef, newPersonIdRef };
};
